import { ServiceHistoryService } from 'api-new/generated';
import { useQuery } from 'react-query';

export const SERVICE_HISTORY_PROOF_QUERY_KEY = 'ServiceHistoryProofQuery';

export const useServiceHistoryProofQuery = (params: { serviceHistoryId: number }, options?: { enabled?: boolean }) =>
  useQuery(
    [SERVICE_HISTORY_PROOF_QUERY_KEY, params.serviceHistoryId],
    () => ServiceHistoryService.getServiceHistoryProofOfService(params.serviceHistoryId),
    {
      enabled: !!params.serviceHistoryId && options?.enabled !== false
    }
  );
